export default "__VITE_ASSET__915e826a__"